/**
 * Serialize Address
 * @param {any} address
 * @returns {string}
 */
export const serializeAddress = (address: any = {}): any => ({
	streetAddress: address?.line1 || '',
	streetAddress2: address?.line2 || '',
	city: address?.city || '',
	state: address?.state || '',
	postalCode: address?.postal_code || '',
	country: address?.country || 'US'
})

export const deserializeAddress = (address: any = {}): any => ({
	line1: address?.streetAddress || '',
	line2: address?.streetAddress2 || '',
	city: address?.city || '',
	state: address?.state || '',
	postal_code: address?.postalCode || '',
	country: address?.country || 'US'
})
